import React, { useEffect } from 'react'
import { useCancelBatchMutation } from '../../../../api-services/financial/currencyExchangeApi'
import { RtkQueryHelper } from '../../../../api-services/shared/RtkQueryHelper'
import { useAppDispatch } from '../../../../app/hooks'
import { setNotification } from '../../../components/ui-widgets/uiWidgetsSlice'
import { type BatchIdActionProps } from './ExchangeInstructionBatchPage'
import { Button } from '@mui/material'

const CancelBatch: React.FC<BatchIdActionProps> = ({ batch }: BatchIdActionProps) => {
  const dispatch = useAppDispatch()

  const [apiProcessBatchTrigger, apiProcessBatchResult] = useCancelBatchMutation()
  const handleClick = async (): Promise<void> => {
    const choice = window.confirm(
      'Are you sure you want to cancel this batch?'
    )
    if (choice) {
      await apiProcessBatchTrigger(batch.batchId)
    }
  }

  useEffect(() => {
    if (apiProcessBatchResult.isSuccess) {
      dispatch(setNotification({ open: true, severity: 'success', message: `Batch ${apiProcessBatchResult.data.batchId} cancelled.` }))
    }

    if (apiProcessBatchResult.isError) {
      dispatch(setNotification({ open: true, severity: 'error', message: RtkQueryHelper.mapResponseError(apiProcessBatchResult.error) }))
    }
  }, [apiProcessBatchResult.isSuccess, apiProcessBatchResult.isError])

  return (
    <>
      <Button type={'button'} variant={'contained'} color={'warning'} disabled={!batch.cancelable} onClick={handleClick}>
        Cancel
      </Button>
    </>
  )
}

export default CancelBatch
